/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * FormErrorMessage CSS
 */
export const styles = css`
  :host {
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  .nile-form-error-message {
    display: flex;
    align-items: center;
    color: var(--nile-form-error-text-color, var(--ng-colors-text-error-primary-600));
    font-family: var(--nile-font-family-serif,var(--ng-font-family-body));
    font-size: var(--nile-form-error-text-font-size, var(--ng-font-size-text-sm));
    font-style: normal;
    font-weight: var(--nile-font-weight-regular, var(--ng-font-weight-regular));
    line-height: var(--nile-form-error-text-line-height,  var(--ng-line-height-text-md));
    letter-spacing: 0.2px;
    margin-top: var(--nile-spacing-sm, var(--ng-spacing-sm));
  }

  .nile-form-error-message__icon {
    display: var(--nile-display-inline-block, var(--ng-display-none));
    margin-right: var(--nile-spacing-sm, var(--ng-spacing-none));
  }
`;

export default [styles];
